import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Marcus D.',
    score: 'Deleted 7 Collections',
    text: 'I was skeptical. I tried Lexington Law for a year and got nothing. Sent the Sledgehammer letter and 30 days later, 7 collections vanished. My score jumped 84 points.'
  }, {
    name: 'Sarah J.',
    score: 'Score: 520 → 710',
    text: "We needed a mortgage but my husband's old medical bills were haunting us. This guide showed us exactly how to challenge them. We closed on our house last month!"
  }, {
    name: 'David R.',
    score: 'Removed Repossession',
    text: "They told me a repo stays for 7 years. The Sledgehammer proved they didn't have the paperwork. Deleted in 45 days. Insane."
  }];
  return <section className="py-20 bg-dark-50" data-id="element-199">
      <div className="max-w-6xl mx-auto px-4" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-white mb-12" data-id="element-201">
          Real Results from Real People
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-202">
          {reviews.map((review, idx) => <div key={idx} className="bg-dark-DEFAULT p-6 rounded-lg border border-success/20 shadow-lg" data-id="element-203">
              <div className="flex gap-1 mb-3" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-205" />)}
              </div>
              <div className="inline-block bg-success/10 border border-success/30 px-2 py-0.5 rounded-full mb-3" data-id="element-206">
                <span className="text-success text-xs font-bold uppercase tracking-wide" data-id="element-207">
                  ✓ Verified Result
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-208">
                {review.score}
              </h3>
              <p className="text-gray-400 mb-6 italic" data-id="element-209">"{review.text}"</p>
              <div className="flex items-center gap-3" data-id="element-210">
                <div className="w-10 h-10 bg-gray-700 rounded-full flex items-center justify-center font-bold text-white" data-id="element-211">
                  {review.name.charAt(0)}
                </div>
                <span className="text-gray-300 font-medium" data-id="element-212">{review.name}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}